import { render, staticRenderFns } from "./CheckForTile.vue?vue&type=template&id=35a857ce&scoped=true&functional=true&"
import script from "./CheckForTile.vue?vue&type=script&lang=js&"
export * from "./CheckForTile.vue?vue&type=script&lang=js&"
import style0 from "./CheckForTile.vue?vue&type=style&index=0&id=35a857ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "35a857ce",
  null
  
)

export default component.exports